<template>
  <div class="flex-column">
    <div
      v-if="pollInfoMessage"
      :class="aligmentCss"
      class="d-flex text-weight-semi-bold"
    >
      <div
        :style="gridTheme"
        :class="[pollInfoMessage.class, cssTheme]"
        class="legend-content text-size-14 flex-row"
      >
        <div class="mx-1">
          <font-awesome-icon class="mx-1" :icon="pollInfoMessage.icon" />
          {{ pollInfoMessage.text }}
        </div>
      </div>
    </div>
    <div
      v-if="isHiddenPoll"
      :class="aligmentCss"
      class="d-flex text-weight-semi-bold"
    >
      <div
        :style="gridTheme"
        class="legend-content text-size-14 flex-row"
        :class="cssTheme"
      >
        <div class="mx-1">
          <font-awesome-icon class="mx-1" :icon="['fas', 'info-circle']" />
          {{ msgHiddenPoll }}
        </div>
      </div>
    </div>

    <div
      v-if="showParticipateBtn"
      :class="aligmentParticipateButton"
      class="d-flex comments-and-todos align-items-start"
    >
      <div
        ref="taskGrid"
        class="view-task-content"
        :style="gridTheme"
        :class="cssParticipateButtonTheme"
      >
        <div class="participate-button text-center">
          <Btn :label="labelParticipateBtn" @click.native="onParticipate" />
        </div>
      </div>
    </div>

    <div :class="cssPage" class="pageView">
      <div :class="aligmentCss" class="d-flex align-items-start">
        <div ref="dataGrid" class="view-content grid-block" :class="cssTheme">
          <div class="grid-wrapper">
            <div
              class="scroll-wrapper"
              :style="{ 'max-width': scrollWrapperMaxWidth + 'px' }"
            >
              <div id="ChoicesBox" class="choices-wrapper">
                <div
                  v-if="0"
                  class="user-time-zone text-size-14"
                  v-html="getProjectInfo()"
                ></div>
                <div
                  v-if="showEventCounts"
                  :class="cssMode"
                  class="event-status align-items-stretch text-size-16 text-weight-semi-bold align-items-start px-3"
                >
                  <div class="col status-block border-2px">
                    <div
                      class="k-row align-items-center justify-content-between"
                    >
                      <div class="event-status-colum">
                        <div class="event-status-title">
                          {{ $t('event.statusInvitations') }}
                        </div>
                        <div class="event-status-value">
                          {{ openEventInvitations }}
                        </div>
                      </div>
                      <div class="event-status-colum">
                        <div class="event-status-title">
                          {{ $t('event.statusConfirmations') }}
                        </div>
                        <div
                          class="event-status-value text-success text-center"
                        >
                          {{ confirmations - guests }}
                          <span
                            v-if="poll.options.limitedVotesPerEvent"
                            class="ml-1"
                          >
                            (+{{ guests }})
                          </span>
                        </div>
                      </div>
                      <div class="event-status-colum">
                        <div class="event-status-title">
                          {{ $t('event.statusDeclines') }}
                        </div>
                        <div class="event-status-value text-danger text-center">
                          {{ declines }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col d-flex justify-content-end align-items-center"
                  >
                    <render-hidden-mode v-if="0" />
                  </div>
                </div>

                <div
                  class="paging"
                  v-if="pagingVisible"
                  :style="{ left: scrollLeft + 'px' }"
                >
                  <font-awesome-icon
                    style="float: left; cursor: pointer;"
                    v-if="leftPagingIconVisible"
                    @click="doScrollLeft"
                    :icon="['fas', 'arrow-alt-left']"
                  />

                  <font-awesome-icon
                    style="float: right; cursor: pointer;"
                    v-if="rightPagingIconVisible"
                    @click="doScrollRight"
                    :icon="['fas', 'arrow-alt-right']"
                  />
                </div>
                <!-- END paging icons -->

                <div class="k-choices">
                  <div class="k-choice-details">
                    <!-- Start choice header (event) -->
                    <div
                      :class="cssMode"
                      class="k-row text-size-14 text-weight-bold k-border-bottom"
                    >
                      <div :class="cssMode" class="k-event-participant-header">
                        <div class="header-row mb-1">
                          <div
                            :class="cssMode"
                            class="header-item grid-section-title text-font-18 text-weight-semi-bold"
                          >
                            <span v-if="isOwner">{{ participantsCount }} </span
                            >{{ $t('polls.invited') }}
                            <span
                              v-if="isOwner"
                              v-on:click="enterNewParticipant()"
                              class="text-primary ml-2"
                            >
                              <font-awesome-icon
                                :icon="['fas', 'plus-circle']"
                              />
                            </span>
                          </div>
                          <RenderSortingIcons v-if="showSortIcons" />
                        </div>
                      </div>

                      <div
                        :class="cssMode"
                        class="k-participant-answer p-1 k-border-left text-center text-size-20"
                      >
                        {{ $t('event.headerComming') }}
                      </div>
                      <div
                        v-if="poll.options.limitedVotesPerEvent"
                        :class="cssMode"
                        class="k-participant-guests p-1 k-border-left text-center text-size-20"
                      >
                        {{ $t('event.headerGuest') }}
                      </div>
                      <div
                        :class="cssMode"
                        class="k-participant-comment-header k-participant-comment p-1 k-border-left justify-content-center text-size-20"
                      >
                        {{ $t('event.HeaderComment') }}
                      </div>
                    </div>
                    <!-- END choice header (event) -->

                    <div class="k-participant-choices">
                      <div
                        v-for="participant in participants"
                        class="k-row"
                        :key="participant.id"
                      >
                        <div
                          :class="[cssMode, isCurrentUserParent(participant)]"
                          class="k-row align-items-strech k-border-bottom"
                        >
                          <div
                            :class="getEditableClass(participant)"
                            class="k-event-participant"
                            @click="startEditParticipant(participant)"
                          >
                            <render-participant
                              :isOwner="isOwner"
                              :tooltip="getEditableTooltip(participant)"
                              :isEmailVisible="isEmailVisible(participant)"
                              :isEditable="isEditable(participant)"
                              :isCurrentUser="participant.isCurrentUser"
                              :participant="participant"
                              ref="participantNotification"
                            />
                          </div>
                          <div
                            @click="editParticipantChoices(participant, $event)"
                            v-if="isAnswered(participant)"
                            :class="getEditableClass(participant)"
                            class="col-container align-items-strech"
                          >
                            <div
                              :class="cssMode"
                              class="k-participant-answer justify-content-center align-items-center k-border-left"
                            >
                              <div
                                v-if="participant.choice > 0"
                                class="k-checked"
                              >
                                <font-awesome-icon :icon="['fas', 'check']" />
                              </div>
                              <div v-else-if="participant.choice == 0" class="">
                                <font-awesome-icon :icon="['fas', 'times']" />
                              </div>
                              <div v-else>
                                <font-awesome-icon :icon="['fal', 'square']" />
                              </div>
                            </div>

                            <div
                              v-if="poll.options.limitedVotesPerEvent"
                              :class="cssMode"
                              class="k-participant-guests justify-content-center align-items-center k-border-left"
                            >
                              <span v-if="participant.choice > 1"
                                >+{{ participant.guests }}</span
                              >
                            </div>

                            <div
                              :class="cssMode"
                              class="k-participant-comment text-size-14 justify-content-start k-border-left"
                            >
                              {{ participant.comment }}
                            </div>
                          </div>
                          <div
                            @click="editParticipantChoices(participant)"
                            v-else
                            class="k-row k-without-answer align-items-center justify-content-center text-standard k-border-left p-1"
                            :class="[getEditableClass(participant), cssMode]"
                          >
                            <div
                              v-if="isEditable(participant)"
                              :class="cssProvideAnswer"
                              class="text-center"
                              v-html="pleaseAnswer"
                            ></div>
                            <div v-else>
                              <font-awesome-icon
                                text-size-14
                                :icon="['fas', 'question']"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- END v-for participants -->

                      <!-- END v-for openInvitations -->
                    </div>

                    <!-- END choice details (answers) -->
                  </div>
                </div>
                <render-invitations
                  :cssMode="cssMode"
                  :invitations="openInvitations"
                >
                  <div class="k-invitation-row"></div>
                </render-invitations>
                <!-- END k-choices -->
              </div>
              <!-- END ChoicesBox -->
            </div>
            <!-- END scroll-wrapper -->
          </div>
          <!-- END grid-wrapper -->
        </div>
      </div>

      <div
        v-if="showTasks"
        :class="aligmentCssComments"
        class="d-flex comments-and-todos align-items-start"
      >
        <div
          ref="taskGrid"
          class="view-task-content"
          :style="gridTheme"
          :class="cssCommentsTheme"
        >
          <div class="grid-wrapper">
            <div class="comments">
              <div
                class="comments-headline grid-section-title mb-2"
                :class="cssMode"
              >
                <div class="d-flex justify-content-between align-items-center">
                  <div>{{ $t('tasks.headline') }} ({{ pollTasks.length }})</div>
                  <div
                    v-if="isRegularOwner"
                    class="text-size-14 align-self-center mt-1 text-weight-regular"
                  >
                    {{ freeTaskCout }} {{ $t('tasks.free') }}
                  </div>
                </div>
              </div>

              <Tasks :tasksList="pollTasks"> </Tasks>
            </div>
          </div>
        </div>
      </div>
      <!-- END tasks -->

      <div :class="aligmentCssComments" class="d-flex align-items-start">
        <div
          v-if="showComments"
          ref="commentGrid"
          class="view-content"
          :class="cssCommentsTheme"
        >
          <div class="grid-wrapper fix-width">
            <div class="comments">
              <div
                class="comments-headline grid-section-title"
                :class="cssMode"
              >
                {{ $t('comments.headline') }}
              </div>

              <Comments
                :commentsList="pollComments"
                v-on:add="addComment"
                v-on:delete="deleteComment"
                :canPostComment="canPostComment"
                :canSeeList="canSeeList"
              ></Comments>
            </div>
          </div>
        </div>
      </div>
      <!-- END comment -->
      <!-- END view-content -->

      <ModalEventChoice ref="dlgEditEventChoice" @update="onUpdate" />

      <ModalParticipant
        ref="newParticipantModal"
        :user="user"
        :invitation="invitation"
        :edit-mode="modalEditMode"
        :edit-participant="editParticipant"
        :is-new-user="isClickToAddNewParticiapnt"
        @save="onSaveModal"
        @cancel="stopEditParticipant"
      >
      </ModalParticipant>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import ModalParticipant from '@/components/UI/ModalParticipant';
import ModalEventChoice from '@/components/UI/ModalEventChoice';

import Comments from '@/components/Rendering/Comments.vue';
import Tasks from '@/components/Rendering/Tasks.vue';
import RenderSortingIcons from './RenderSortingIcons.vue';
import RenderParticipant from './RenderParticipant';
import RenderHiddenMode from './RenderHiddenMode';
//import RenderHiddenModeParticipant from './RenderHiddenModeParticipant';
import RenderInvitations from '@/components/Rendering/RenderInvitations.vue';

import { renderMixin } from '../mixins/RenderMixins';
import { gridMixin } from '../mixins/GridMixins';
import { eventMixin } from '../mixins/EventMixins';
import { themeMixin } from '../mixins/ThemeMixins';
import { pollMixin } from '../mixins/PollMixins.js';
import { answerMixin } from '../mixins/AnswerMixins.js';
import { modalParticipantMixins } from '../mixins/ModalParticipantMixins';
import sortParticipants from '@/shared/sortParticipants';

export default {
  name: 'RenderEvent',
  mixins: [
    renderMixin,
    gridMixin,
    eventMixin,
    modalParticipantMixins,
    themeMixin,
    pollMixin,
    answerMixin,
  ],
  components: {
    ModalParticipant,
    ModalEventChoice,
    Comments,
    Tasks,
    RenderParticipant,
    RenderSortingIcons,
    RenderInvitations,
    RenderHiddenMode,
  },

  data() {
    return {
      // data for scrolling, resize, participants
      participantPaddingBottom: 0,
      scrollWidth: 0,
      clientWidth: 0,
      offsetWidth: 0,
      choiceColumnWidth: 0,
      scrollWrapperMaxWidth: 1000,
      pagingVisible: false,
      scrollLeft: 0,
      leftPagingIconVisible: false,
      rightPagingIconVisible: true,
      // end scrolling data

      selectedParticipant: null,
      currentUserParticipantIds: [],
      isClickToAddNewParticiapnt: true,
    };
  },

  methods: {
    ...mapActions(['addComment', 'deleteComment']),

    // cssChoice(id) {
    //   if (this.poll.type === 1) return 'choice-text';
    //   return 'choice-text-survey choice-' + id;
    // },

    // getProjectInfo() {
    //   return "test";
    // },

    getProjectInfo() {
      console.log(
        'Options:',
        this.poll.options.hiddenPoll,
        this.poll.options.limitedVotesPerChoice
      );
      if (
        this.poll.options.hiddenPoll ||
        this.poll.options.limitedVotesPerChoice
      ) {
        let html =
          "<span class='text-size-12'>" +
          this.$t('options.options') +
          ': </span>';
        let shownOption = 0;
        if (this.poll.options.hiddenPoll) {
          html += "<span class=''>" + this.$t('options.hiddenPoll') + '</span>';
          shownOption = 1;
        }
        if (this.poll.options.limitedVotesPerChoice) {
          console.log(shownOption);

          let optionText = this.$t('options.limitVotesPerChoice').replace(
            '%d',
            this.poll.options.votesLimit
          );
          if (shownOption > 0) {
            optionText = ';' + optionText;
          }
          let optionHtml = "<span class=''>" + optionText + '</span>';
          console.log(shownOption, optionHtml);
          html = html + optionHtml;
        }
        return html;
      }
      return null;
    },

    choiceText(choice) {
      var element = document.getElementsByClassName('class-' + choice.id);
      if (!element) return choice.text;

      element.h;
      var $p = $('#fos p');
      var divh = $('#fos').height();
      while ($p.outerHeight() > divh) {
        $p.text(function (index, text) {
          return text.replace(/\W*\s(\S)*$/, '...');
        });
      }
    },

    saveEditParticipant() {
      this.$store.dispatch('updateParticipant', this.editParticipant);
      this.stopEditParticipant();
    },

    getCurrentInvitation() {
      if (this.curInvitation && !this.curInvitation.participant_id) {
        return this.curInvitation.id;
      }
      return null;
    },
    // START new participant / edit participant

    // START component helper functions
    getAnswerForChoice(participant, choice) {
      var choiceId = choice.id;
      if (participant && choiceId && participant.preference_list) {
        let preferenceForChoice = participant.preference_list.find(
          (preference) => preference.choice_id === choiceId
        );
        if (preferenceForChoice) {
          return preferenceForChoice.value;
        }
      }
      return -1;
    },

    getEditableClass(participant) {
      let classes = '';
      if (this.isEditable(participant)) {
        classes = ' editable';
      }
      return classes;
    },

    getEditableTooltip(participant) {
      return this.isEditable(participant)
        ? this.$t('polls.clickToEditName')
        : '';
    },

    // START scrolling, resize, participants
    setScrollbarData(resetScrollLeft = true) {
      const choicesBox = document.getElementById('ChoicesBox');
      const aside = document.getElementsByClassName('aside')[0];
      const gridBlock = document.getElementsByClassName('grid-block');
      const offsetLeft = gridBlock[0].offsetLeft;

      let heightDiff = 0;
      if (choicesBox) {
        // if scrollbar is on the right, it will not dissapear on resize
        // so set scrollLeft to 0 (scrollbar to the left side)
        // but only on resize not in Vue updated event hook
        if (resetScrollLeft) {
          choicesBox.scrollLeft = 0;
          //console.log('scrollLeft set to 0');
        }

        choicesBox.removeEventListener('scroll', this.getScrollPos);
        choicesBox.addEventListener('scroll', this.getScrollPos);

        // there is a difference between offsetHeight and clientHeight if a scrollbar is visible
        // difference equals the hight of scrollbar
        heightDiff = choicesBox.offsetHeight - choicesBox.clientHeight;

        // client/offsetHeight = visible part of choices box
        this.clientWidth = choicesBox.clientWidth;
        this.offsetWidth = choicesBox.offsetWidth;

        // scrollWidth = total width of choices box
        this.scrollWidth = choicesBox.scrollWidth;
      } else {
        console.error('no choicesBox!!');
      }
      if (aside) {
        // aside.getBoundingClientRect().x = x pos on page of aside-div (= 2vw = 2% of window width)
        // multiply by 2 to have same margin on the right
        // aside.clientWidth = width of participant column
        // +20 due to padding-right: 20px of grid-wrapper

        this.scrollWrapperMaxWidth =
          window.innerWidth -
          (aside.getBoundingClientRect().x * 2 + aside.clientWidth + 20);
      } else {
        this.scrollWrapperMaxWidth = window.innerWidth - 2 * offsetLeft - 40;
      }

      console.log(
        'scrollWrapperMaxWidth: ',
        this.scrollWrapperMaxWidth,
        window.innerWidth
      );

      let choiceDetails = document.getElementsByClassName(
        'k-choice-details'
      )[0];
      if (choiceDetails) {
        this.choiceColumnWidth = choiceDetails.clientWidth;
      }

      // this.choiceColumnWidth = document.getElementsByClassName(
      //   'k-choice-details'
      // )[0].clientWidth;

      // add padding-bottom to participant with the same value as hight of scrollbar (or 0)
      this.participantPaddingBottom = heightDiff;
      //console.log('setScrollbarData: ', heightDiff);

      // add paging icon div, if more than half of a choice column is not visible
      this.pagingVisible =
        this.clientWidth < this.scrollWidth - this.choiceColumnWidth / 2;
    },

    // get the position of the choices scrollbar and set visibility of left/right paging icon accordingly
    getScrollPos() {
      const choicesBox = document.getElementById('ChoicesBox');
      this.scrollLeft = choicesBox.scrollLeft;
      this.leftPagingIconVisible = this.scrollLeft > this.choiceColumnWidth / 2;
      this.rightPagingIconVisible =
        this.scrollWidth - this.clientWidth - this.scrollLeft >
        this.choiceColumnWidth / 2;
    },

    // scroll left the width of a choice column
    doScrollLeft() {
      const choicesBox = document.getElementById('ChoicesBox');
      choicesBox.scrollLeft < this.choiceColumnWidth
        ? (choicesBox.scrollLeft = 0)
        : (choicesBox.scrollLeft -= this.choiceColumnWidth);
      this.getScrollPos();
    },

    // scroll right the width of a choice column
    doScrollRight() {
      const choicesBox = document.getElementById('ChoicesBox');
      this.scrollWidth - this.clientWidth - this.scrollLeft <
      this.choiceColumnWidth
        ? (choicesBox.scrollLeft = this.scrollWidth - this.clientWidth)
        : (choicesBox.scrollLeft += this.choiceColumnWidth);
      this.getScrollPos();
    },
    // END scrolling, resize, participants
    isCurrentUserParent(participant) {
      if (participant.isCurrentUser || participant.isCurrentUserParticipant) {
        return ' is-current-user-parent';
      }
      return '';
    },
  },

  computed: {
    ...mapGetters([
      'isOwner',
      'isPollEditable',
      'pollTasks',
      'userName',
      'isAuthenticated',
      'user',
      'userId',
      'pollComments',
      'isPublicLink',
      'isAdminLink',
      'isDarkMode',
    ]),

    isDateType() {
      return this.poll.type == 1;
    },

    isInvitedUser() {
      if (this.curInvitation) return true;
      return false;
    },

    choices() {
      if (this.poll.type == 1) {
        return this.poll.choices.filter((choice) => {
          if (choice.start == null) return false;
          return true;
        });
      }
      if (this.poll.type == 3) {
        return this.poll.choices.filter((choice) => {
          if (choice.start == null) return true;
          return false;
        });
      }
      return this.poll.choices;
    },

    participantsCount() {
      return this.poll.participants.length;
    },

    ...mapState({
      curInvitation: (state) => state.curInvitation,
      poll: (state) => state.poll.poll,
      ownerId: (state) => state.poll.poll.user.id,
      keyUserId: (state) => state.keyUserId,
    }),

    mayBeAnswersEnabled() {
      return this.poll.options.mayBeAnswers;
    },
    fontColor() {
      if (this.isDarkMode) {
        return 'white-color';
      }
      return 'dark-grey-color';
    },
  },

  mounted() {
    console.log('(RenderEvent) userID:', this.userId);
    let participants = this.identifyCurrentUser(this.poll.participants);

    sortParticipants(participants, this.userId);
    this.$store.commit('updateParticipants', participants);

    this.setScrollbarData(false);
    this.updateRowMode();

    const currentParticipant = this.getCurrentParticipant();
    // if current participnat exist the user is logged in or identified by the lastParticipant
    if (currentParticipant) {
      return;
    }

    const doEnterNewParticipant = this.isNewParticipantRequired();
    if (doEnterNewParticipant) {
      this.enterNewParticipant(true);
    }
  },
  updated() {
    this.setScrollbarData(false);
  },
  // set resize event handler on created
  created() {
    window.addEventListener('resize', this.setScrollbarData);
    window.addEventListener('resize', this.updateRowMode);
    let currentUserAssigned = false;
    this.poll.participants.map((participant) => {
      if (this.user && participant.user) {
        participant.isCurrentUser =
          this.user.id === participant.user.id && !currentUserAssigned;
        participant.isCurrentUserParticipant =
          this.user.id === participant.user.id;
        if (this.user.id === participant.user.id) {
          currentUserAssigned = true;
        }
      } else {
        participant.isCurrentUser = false;
        participant.isCurrentUserParticipant = false;
      }

      return participant;
    });
  },
  watch: {
    'poll.participants': {
      deep: true,
      handler() {
        this.currentParticipant = this.getCurrentParticipant();
        let found = false;
        for (let i = 0; i < this.poll.participants.length; i++) {
          if (
            this.poll.participants[i].isCurrentUser == true &&
            this.poll.participants[i].user &&
            this.poll.participants[i].user.id == this.ownerId
          ) {
            found = true;
            this.$refs['participantNotification'][0].compareChoices();
            break;
          }
        }
        if (found == false) {
          this.$refs['participantNotification'][
            this.$refs['participantNotification'].length - 1
          ].compareChoices();
        }
      },
    },
  },

  // remove resize event handler on destroyed
  destroyed() {
    window.removeEventListener('resize', this.setScrollbarData);
    window.removeEventListener('resize', this.updateRowMode);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '@/styles/style';

$bg-color: rgba(255, 255, 255, 0.3);

.editable {
  cursor: pointer;
}

.button-round {
  border-radius: 50%;
}

.grid-wrapper {
  display: flex;
  flex-direction: row;

  & .scroll-wrapper {
    overflow: hidden;
    max-width: 70vw;
  }
}

.break {
  flex-basis: 100%;
  height: 0;
}

.choices-wrapper {
  overflow: auto;
  display: flex;
  flex-direction: column;
  // uncomment the next two lines if scrolbars should be hidden in general
  // -ms-overflow-style: none;  /* Internet Explorer 10+ */
  // scrollbar-width: none;  /* Firefox */

  & .paging {
    width: 100%;
    color: red;
    position: relative;
  }
}
/*.choices-wrapper .paging {
  width: 100%;
  color: red;
  position: relative;
}*/
.choices-wrapper::-webkit-scrollbar {
  /* WebKit */
  // uncomment the next two lines if scrolbars should be hidden in general
  // width: 0;
  // height: 0;
}

.dayMonth {
}

.timeRange {
  white-space: nowrap;
}

// .choice-text {
//   height: 30px;
//   max-width: 200px;
//   overflow: hidden;
//   white-space: nowrap;
//   text-overflow: ellipsis;
// }

// .choice-text-survey {
//   min-width: 120px;
//   max-width: 240px;
//   height: 100%;
//   overflow: hidden;
//   overflow-wrap: break-word;
//   word-break: break-word;
//   hyphens: auto;
//   -moz-hyphens: auto;
//   display: flex;
//   flex-grow: 1;
// }

.k-participant-choices {
  display: flex;
  flex-direction: column;
  justify-content: stretch;
}

.k-padding {
  padding: 0.3em;
}

.k-p-icon {
  padding-right: 10px;
}

.info-box {
  position: absolute;
  bottom: 200px;
}

.is-current-user {
  font-weight: 800;
}
.k-no-answer {
  overflow-wrap: break-word;
  text-align: center;
}

.k-col {
  display: flex;
  flex-direction: column;
  height: 100%;
  flex-grow: 1;
}

.k-participant-answer,
.k-participant-guests {
  width: 120px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex-grow: 1;
}

.k-participant-guests {
  padding-top: 3px;
}

.k-participant-companions {
  width: 120px;
  height: 100%;
  overflow: hidden;
  overflow-wrap: break-word;
  word-break: break-word;
  justify-content: center;
  hyphens: auto;
  -moz-hyphens: auto;
  display: flex;
  flex-grow: 1;
}

.k-participant-comment,
.k-participant-comment-header {
  width: 240px;
  padding: 10px;
}

.k-participant-comment {
  overflow: hidden;
  padding-top: 5px;
  overflow-wrap: break-word;
  word-break: break-word;
  hyphens: auto;
  -moz-hyphens: auto;
  display: flex;
  flex-grow: 1;
}

.k-without-answer {
  display: flex;
  flex-grow: 1;
}

.k-event-participant,
.k-event-participant-header {
  width: 256px;
  display: flex;
}

.k-event-participant-header {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  width: 256px;

  flex-grow: 1;
  & .header-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
  & .header-item {
    padding: 0 10px;
  }
}

.col-container {
  display: flex;
}

.col {
  flex: 1;
}

.dark-grey-color {
  color: $dark-grey;
}
.white-color {
  color: $white;
}
.k-participant-guests.justify-content-center.align-items-center.k-border-left {
  color: $secondary;
}

.status-block {
  background-color: $dark-grey;
  color: white;
  padding: 5px;
  padding-left: 32px;
  padding-right: 32px;
  border-radius: 10px;
}

.fix-width {
  width: 380px;
}
.is-current-user-parent {
  border-top: 2px solid;
  border-bottom: 3px solid !important;
  border-right: unset;
  border-left: unset;
}

.please-answer {
  text-decoration: underline;
}
</style>
